import { LightPayload } from "../utilities/types";

export const lightService = {
  async controlLights(payload: LightPayload) {
    const response = await fetch(`http://localhost:9378/control`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        device_id: payload.device_id,
        local_key: payload.local_key,
        table_id: payload.table_id,
        action: payload.action,
        ip: payload.ip_address || "Auto",
      }),
    });

    if (response.ok) {
      return await response.json();
    }

    throw new Error("Failed to control lights");
  },
};
